import { flexRender } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";
import type { Table as TableType } from "~/shared/react-table/app-table";

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "~/components/table";
import { useTrends } from "~/contexts/trends-context";
import { IProduct } from "~/integrations/firebase/collections";
import { columns } from "./columns";

interface ExportTableProps {
  table: TableType<IProduct>;
}

export const ExportTable = ({ table }: ExportTableProps) => {
  const { t } = useTranslation(["projects"]);
  const { isLoadingTrends } = useTrends();

  if (isLoadingTrends) {
    return;
  }

  return (
    <div className="space-y-4 text-left">
      <Table>
        <TableHeader>
          {table.getHeaderGroups().map((headerGroup) => (
            <TableRow key={headerGroup.id}>
              {headerGroup.headers.map((header) => (
                <TableHead key={header.id} colSpan={header.colSpan}>
                  {header.isPlaceholder
                    ? null
                    : flexRender(
                        header.column.columnDef.header,
                        header.getContext(),
                      )}
                </TableHead>
              ))}
            </TableRow>
          ))}
        </TableHeader>
        <TableBody>
          {table.getRowModel().rows?.length ? (
            table.getRowModel().rows.map((row) => (
              <TableRow
                key={row.id}
                data-state={row.getIsSelected() && "selected"}
              >
                {row.getVisibleCells().map((cell) => (
                  <TableCell key={cell.id}>
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </TableCell>
                ))}
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={columns.length} className="h-24 text-center">
                {t("projects:exportModal.noResults")}
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
};
